import styled from 'styled-components';

export const ControlsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap-reverse;
    gap: 0.6rem;
`;
